import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {barrage,barrages,barrageTop,barrageAudit,barrageConfig,barrageConfigs,
    barrageTitle,barrageSpanTime,barrageOpenTime,barrageUploadImg,barrageExtract,barragePush} = api

/**
 * 查找配置列表
 */
export async function findBarrageConfigs(params) {
    return request({url: barrageConfigs, method: 'get', data: params,})
}
/**
 * 创建或更新配置
 */
export async function createBarrageConfigs(params) {
    return request({url: barrageConfigs, method: 'post', data: params,})
}
/**
 * 查找配置详情
 */
export async function findBarrageConfig(params) {
    return request({url: barrageConfig, method: 'get', data: params,})
}
/**
 * 查找消息列表
 */
export async function findBarrageMessage(params) {
    return request({url: barrages, method: 'get', data: params,})
}
/**
 * 删除配置
 */
export async function deleteBarrageConfig(params) {
    return request({url: barrageConfig, method: 'delete', data: params,})
}

/**
 * 删除消息
 */
export async function deleteBarrageMessage(params) {
    return request({url: barrage, method: 'delete', data: params,})
}

/**
 * 查找标题id
 */
export async function findBarrageTitle(params) {
    return request({url: barrageTitle, method: 'get', data: params,})
}

/**
 * 消息审核
 */
export async function pendingBarrageMessage(params) {
    return request({url: barrageAudit, method: 'post', data: params,})
}

/**
 * 消息置顶
 */
export async function updateBarrageTop(params) {
    return request({url: barrageTop+'?top='+params.top, method: 'put', data: params,})
}
/**
 * 发送消息
 */
export async function sendBarrageMessage(params) {
    return request({url: barrages, method: 'post', data: params,})
}
/**
 * 推送消息
 */
export async function pushBarrage(params) {
    return request({url: barragePush, method: 'get', data: params,})
}
/**
 * 查找弹幕
 */
export async function findBarrageSpanTime(params) {
    return request({url: barrageSpanTime, method: 'get', data: params,})
}
/**
 * 抽取弹幕
 */
export async function findBarrageExtract(params) {
    return request({url: barrageExtract, method: 'get', data: params,})
}
/**
 * 更新弹幕时间
 */
export async function updateBarrageOpenTime(params) {
    return request({url: barrageOpenTime, method: 'put', data: params,})
}
/**
 * 上传背景
 */
export async function uploadImgBarrage(params) {
    return request({url: barrageUploadImg+'?backgroundImg='+params.backgroundImg, method: 'put', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/barrage.js